import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem;
`;

const SuccessIcon = styled.div`
  color: #48bb78;
  font-size: 4rem;
  margin-bottom: 1.5rem;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #2d3748;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 2rem;
  max-width: 600px;
`;

const PurchaseDetails = styled.div`
  background: #f7fafc;
  border-radius: 8px;
  padding: 1.5rem;
  width: 100%;
  max-width: 500px;
  margin-bottom: 2rem;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

const DetailLabel = styled.span`
  font-weight: 500;
  color: #4a5568;
`;

const DetailValue = styled.span`
  font-weight: 600;
  color: #2d3748;
`;

const Button = styled.button`
  background: #4299e1;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #3182ce;
  }
`;

interface ConfirmationStepProps {
  plan: {
    name: string;
    price: number;
    period?: string;
  };
  formData: {
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
  };
  user?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    companyName: string;
  };
}

export const ConfirmationStep: React.FC<ConfirmationStepProps> = ({ 
  plan, 
  formData,
  user 
}) => {
  // Use user data if available, otherwise fall back to formData
  const userData = user || formData;
  
  const handleGoToDashboard = () => {
    window.location.href = '/dashboard';
  };

  return (
    <Container>
      <SuccessIcon>
        <FontAwesomeIcon icon={faCheckCircle} />
      </SuccessIcon>
      <Title>Thank you for your purchase!</Title>
      <Message>
        Your account has been created and your subscription is now active. 
        You can now access all features of your {plan.name} plan.
      </Message>
      
      <PurchaseDetails>
        <DetailRow>
          <DetailLabel>Plan</DetailLabel>
          <DetailValue>{plan.name}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Price</DetailLabel>
          <DetailValue>${plan.price}{plan.period ? `/${plan.period}` : ''}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Account</DetailLabel>
          <DetailValue>{userData.email}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Name</DetailLabel>
          <DetailValue>{userData.firstName} {userData.lastName}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Company</DetailLabel>
          <DetailValue>{userData.companyName}</DetailValue>
        </DetailRow>
      </PurchaseDetails>
      
      <Button onClick={handleGoToDashboard}>
        Go to Dashboard
      </Button>
    </Container>
  );
}; 